import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon, MapPinIcon, BriefcaseIcon, ShieldCheckIcon, LockIcon, CreditCardIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const chips = [{
  icon: FileTextIcon,
  label: '100% PDF'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: MapPinIcon,
  label: 'Para Argentina'
}, {
  icon: BriefcaseIcon,
  label: 'Emprendedores'
}];
const trust = [{
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago'
}, {
  icon: SmartphoneIcon,
  label: 'Android & iOS'
}];
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-83" data-mp="nb6kflpmn9kz">
      <div className="mx-auto max-w-4xl px-5 pb-[5px] text-center sm:pt-16" style={{
      paddingTop: "25px"
    }} data-id="element-84" data-mp="3d1ii934hv0k9">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="text-[10px] font-extrabold uppercase tracking-[0.25em] text-gold" style={{
        marginTop: "5px",
        marginBottom: "5px"
      }} data-id="element-85" data-mp="382p9fo05jxqf">
          🏆 SIGMA SMART™
        </motion.p>

        <span className="font-display text-[26px] font-bold text-cemento-soft sm:text-[30px]" style={{
        fontSize: "24px",
        fontWeight: "800"
      }} data-id="element-86" data-mp="39al9cd2bwm2m">
          El paso a paso para tu negocio, resuelto desde hoy
        </span>

        <motion.h1 initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="font-display text-center font-extrabold tracking-tight text-gold" style={{
        fontSize: "20px",
        fontWeight: "700",
        paddingTop: '11px',
        paddingBottom: "10px"
      }} data-id="element-87" data-mp="30hreh7aefe3n">
          ACADEMIA CEMENTO ELITE ™
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative mx-auto w-full max-w-md" data-id="element-88" data-mp="2vglq1lnruczx">
          <div className="absolute inset-0 -z-10 mx-auto h-64 w-64 translate-y-6 rounded-full bg-gold/20 blur-3xl" data-id="element-89" data-mp="s1rqqjt21ys6" />
          <img src="https://cdn.magicpatterns.com/uploads/ntzu4JujaqHjqBxiHUzWFy/ChatGPT_Image_3_ago_2026,_18_54_48.png" alt="Academia Cemento Elite — 12 tomos y 5 bonos en formato digital" className="animate-floaty mx-auto h-[300px] w-[300px] max-w-full rounded-2xl object-contain" data-id="element-90" data-mp="nb1ld6kmpvxh" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} className="mt-3 pt-[5px] text-xs font-semibold uppercase tracking-[0.18em] text-cemento-deep" data-id="element-91" data-mp="1b15prg5n5zpj">
          El sistema N°1 para fabricar y vender objetos de lujo en cemento desde tu casa
        </motion.p>

        <div className="mt-9" data-id="element-92" data-mp="x0uywd4c0l4d">
          <div className="mt-6" style={{
          marginTop: "-20px",
          marginBottom: "-20px"
        }} data-id="element-93" data-mp="3lsypkqaae6eu">
            <CTAButton href="#value" data-id="element-94" data-mp="3lqm4i498ffxk">Ver la oferta</CTAButton>
            <p className="mx-auto mt-4 max-w-2xl text-[14px] text-white/70 sm:text-lg" data-id="element-95" data-mp="3hpsdv34enn0z">
              Todo lo que necesitás para fabricar piezas sin grietas, conseguir materiales al mejor
              precio y vender con margen real. Sin improvisar. Sin desperdiciar material en cada
              intento.
            </p>
          </div>

          <motion.h2 initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="mx-auto mt-6 max-w-2xl text-[16px] font-bold text-cemento-soft sm:text-xl" style={{
          paddingTop: "11px"
        }} data-id="element-96" data-mp="2b0pmb26zqsgz">
            Fabricación Pro + Proveedores Argentina + Costos Reales + Fotografía + Meta Ads
          </motion.h2>

          <div className="mt-7 flex flex-wrap justify-center gap-2.5 pt-[7px]" style={{
          paddingTop: "0px"
        }} data-id="element-97" data-mp="2p1s8rg1we4sf">
            {chips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-white/5 px-3.5 py-1.5 text-xs font-semibold text-white/80" data-id="element-98" data-mp="umpt0a2ni12p">
                <Icon className="h-3.5 w-3.5 text-gold" data-id="element-99" data-mp="zndq9dhh3e5d" />
                {label}
              </span>)}
          </div>

          <p className="mt-4 whitespace-pre-line pt-[7px] pb-[6px] text-sm font-semibold text-white/50" data-id="element-100" data-mp="3vhxgzllx9bzl">
            {'12 Tomos · 5 Bonos · +100 páginas\n· TODO RESUELTO ·'}
          </p>
        </div>

        <div className="mt-[10px] mb-[10px] flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-white/50" data-id="element-101" data-mp="9aqlm64mnqtu">
          {trust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-102" data-mp="3crfrrr0asyiz">
              <Icon className="h-4 w-4 text-cemento" data-id="element-103" data-mp="3cpcsegd99t1l" />
              {label}
            </span>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05
      }} className="mt-[18px] mb-[18px] inline-flex items-center gap-2 rounded-full border border-gold/40 bg-gold/10 px-4 py-[4px] text-xs font-bold uppercase tracking-wide text-gold" data-id="element-104" data-mp="3mpdfmde8wtb2">
          🔥 Oferta de lanzamiento — El precio cierra pronto · No vuelve
        </motion.div>
      </div>
    </header>;
}